import { Controller } from "stimulus";
import Choices from "choices.js";

export default class extends Controller {
  static targets = ["coinSelect", "coinCategorySelect", "paywallEndDateTime", "isPaywall", "pinned", "pinStartDate", "pinEndDate"];

  connect() {
    new Choices(this.coinSelectTarget, {
      removeItemButton: true,
    });

    new Choices(this.coinCategorySelectTarget, {
      removeItemButton: true,
    });
  }

  setPaywallEndDateTimeToNextWeek(e) {
    if (e.target.checked === true) {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      this.paywallEndDateTimeTarget.value = date.toISOString().slice(0, 16);
    } else {
      this.paywallEndDateTimeTarget.value = "";
    }
  }

  onPinnedChange(e) {
    const defaultDate = new Date().toISOString().split('T')[0].slice(0, 10);

    if (this.pinnedTarget.checked) {
      this.pinStartDateTarget.value = this.previousPinStartDate || defaultDate;
      this.pinEndDateTarget.value = this.previousPinEndDate || defaultDate;
    } else {
      this.previousPinStartDate = this.pinStartDateTarget.value || defaultDate;
      this.previousPinEndDate = this.pinEndDateTarget.value || defaultDate;
      this.pinStartDateTarget.value = "";
      this.pinEndDateTarget.value = "";
    }
  }

  validatePinnedDates(e) {
    if (!this.pinnedTarget.checked && !this.pinStartDateTarget.value && !this.pinEndDateTarget.value)
      return;

    if (this.pinStartDateTarget.value && this.pinEndDateTarget.value) {
      let pinStart = new Date(this.pinStartDateTarget.value);
      let pinEnd = new Date(this.pinEndDateTarget.value);

      if (pinEnd < pinStart) {
        alert("Pin start date must be before pin end date.");
        return e.preventDefault();
      }

      if (pinStart > pinEnd) {
        alert("Pin end date must be after pin start date.");
        return e.preventDefault();
      }
    } else {
      alert("Both pin start date and pin end date must be filled.")
      return e.preventDefault();
    }
  }

  toggleSection(e) {
    let parent = e.currentTarget.parentElement;
    parent.querySelector(".card-body").classList.toggle("tw-hidden");
    parent.querySelector(".fa-angle-up").classList.toggle("d-none");
    parent.querySelector(".fa-angle-down").classList.toggle("d-none");
  }
}
